export const silaeSynchronizationCacheKeys = {
  all: queryParams => ['silae', queryParams] as const,
  update_silae_sync: () => ['update_silae_sync'] as const
}
